import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AnimatedSeparator from '../components/AnimatedSeparator';

export default function AboutElaPage() {
    const [epubSuccess, setEpubSuccess] = useState(false);
 
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('epub') === 'success') {
            setEpubSuccess(params.get('epub') === 'success');
            window.history.replaceState({}, '', '/about');
        }
    }, []);

    return (
        <div className="page-container">
            <div className="container">

                {epubSuccess && (
                    <div style={{
                        background: '#f52e72',
                        color: '#fff',
                        padding: '1rem 1.5rem',
                        marginBottom: '2rem',
                        borderRadius: '4px',
                    }}>
                        <strong>You're all set!</strong> Check your email — your EPUB download link is on its way.
                    </div>
                )}

                {/* ── HERO ── */}
                <div className="row page-hero align-items-end">
                    <div className="col-md-7">
                        <h1>Ela Shapira</h1>
                        <h2>Startup Doula; an impatient goblin on a mission to build the Martriarchy.</h2>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* ── STORY ── */}
                <div className="row">
                    <div className="col-md-3">
                        <h3>My story</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <p>I believe in building a life we don't need a vacation from.</p>
                        <p>
                            My 20 years in early-stage startups taught me how to grow ideas into income —
                            without burning through time, money, or sanity. I've done it the wrong way more
                            than once, which is why I know what the right way looks like.
                        </p>
                        <p>
                            I authored 2 patents, worked as a Chief Technological Officer, co-founded several
                            startups, and wrote a book about all of it.
                        </p>
                        <p>
                            My special talent is translating startup-lingo into human language — and finding
                            out how something can work despite everyone saying it can't.
                        </p>
                        <p>
                            Since my teens I've been searching for the balance between Eastern enlightenment
                            and Western ambition. I found mine in a country house in Catalonia, with dogs,
                            cats, chickens, and geese.
                        </p>
                        <p>
                            Now I want to help you find yours — with a startup that works for your life,
                            not against it.
                        </p>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                {/* ── BOOK ── */}
                <div className="row">
                    <div className="col-md-3">
                        <h3 style={{ color: '#f52e72' }}>My book</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <div className="book-block">
                            {/* TODO: add actual book cover image to public/images/book-cover.jpg */}
                            <div className="book-details">
                                <h5>Secrets of a Startup Doula <br />cautionary tales about startups, based on true stories</h5>
                                <p>
                                    This book is not another glorious success story that is impossible to replicate, nor another manual for building a startup from your idea.
                                </p>
                                <p>
                                    This book is a collection of the warning labels that should have been on those manuals. It's about how life happens while you try to create a startup and messes up your plans.
                                </p>
                                <p>
                                    It's the advice I wish I had when I was starting out.
                                </p>
                                <div className="book-actions btn-row">
                                    <a
                                        href="https://www.amazon.com/dp/B0FRT29MJY"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn-secondary"
                                    >
                                        Buy on Amazon (paperback)
                                    </a>
                                    <Link className="btn-primary"
                                        onClick={async () => {
                                            try {
                                                const res = await fetch(
                                                    `${process.env.REACT_APP_API_URL}/checkout/epub`,
                                                    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }
                                                );
                                                const { checkoutUrl } = await res.json();
                                                window.location.href = checkoutUrl;
                                            } catch {
                                                alert('Something went wrong — please try again.');
                                            }
                                        }}
                                    >
                                        Buy directly (EPUB)
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* ── PROJECTS ── */}
                <div className="row">
                    <div className="col-md-3">
                        <h3>Other projects</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">

                        <div className="project-card">
                            <h5>The Mycelium</h5>
                            <p>Founder</p>
                            <p>
                                Global directory of women service providers—making it easy to consciously choose a woman when hiring, buying, and investing—and a Bank of Hours.
                            </p>
                            <a
                                href="https://www.themycelium.org/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                themycelium.org
                            </a>
                        </div>

                        <div className="project-card">
                            <h5>Emprendeplan</h5>
                            <p>Mentress</p>
                            <p>
                                The first hybrid business school for women entrepreneurs in rural areas.
                            </p>
                            <a
                                href="https://www.emprendeplan.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                emprendeplan.com
                            </a>
                        </div>

                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                {/* ── NEWSLETTER ── */}
                <div className="row">
                    <div className="col-md-6">
                        <h5>My newsletter</h5>
                        <p style={{ marginBottom: '1.5rem' }}>
                            Feminist thoughts about startups. Sent every other Friday.
                        </p>
                        <a
                            href="https://startup-doula.beehiiv.com/"
                            target="_blank"
                            rel="noreferrer"
                            className="btn-primary"
                        >
                            Subscribe on Beehiiv
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
}
